var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "width",
    height: "height",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2 0A5 5 0 1 1 7 7a5 5 0 0 1 10 0m-9 9c-1.491 0-2.729 1.991-2.96 4h13.92c-.231-2.009-1.469-4-2.96-4zm-5 4.667C3 21.403 3.448 22 4 22h16c.552 0 1-.597 1-1.333C21 16.985 18.761 14 16 14H8c-2.761 0-5 2.985-5 6.667",
    clipRule: "evenodd"
  })));
};
export default SvgPerson;